export const LICENSE_ID = 6817451



// WEBPACK FOOTER //
// ./src/shared/liveChat.js